import 'magnific-popup'

if ($('.js-video-btn').length) {

  $('.js-video-btn').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,    
  })

}
